import { render, staticRenderFns } from "./DriverWithdrawal.vue?vue&type=template&id=c2518506&scoped=true&"
import script from "./DriverWithdrawal.vue?vue&type=script&lang=js&"
export * from "./DriverWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./DriverWithdrawal.vue?vue&type=style&index=0&id=c2518506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2518506",
  null
  
)

export default component.exports